import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import {
  Avatar,
  Flex,
  getTheme,
  Space,
  Text,
  useMediaQuery,
} from '@conexasaude/conexa-hero'
import { useAttendanceCallStore } from '../../store/useAttendanceCall'

const CallStartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const theme = getTheme()
  const { closeModal } = useModalContext()
  const attendanceCall = useAttendanceCallStore(store => store.attendanceCall)
  const isMobile = useMediaQuery(`(max-width: ${theme.grid.breakpoint.sm})`)

  const handleSucess = useCallback(() => {
    closeModal()
    hookSuccess()
  }, [closeModal, hookSuccess])

  const textVariant = isMobile ? 'paragraphSmall' : 'paragraphLarge'

  return (
    <Modal
      id="CALL_STARTED"
      primaryAction={handleSucess}
      primaryActionLabel="Acessar agora"
      primaryActionId="SalaDeEsperaImediata-IniciarConsulta-CTA_IniciarConsulta"
    >
      <Space mt="lg" />
      <Flex direction="column">
        <Text variant={textVariant}>
          A pessoa que irá te atender já está te aguardando.
        </Text>
        <Text
          variant={textVariant}
          color={theme.colors.neutral[400]}
          fontWeight={600}
        >
          Acesse em até 2 minutos para não perder a sua consulta.
        </Text>
        <Space mt="lg" />
        <Text variant={textVariant}>Quem irá te atender:</Text>
        <Space mb="sm" />

        <Flex>
          <Avatar size={45} src={attendanceCall?.urlPhoto} />
          <Flex ml="md" direction="column">
            <Text ellipsis variant="headingSmall">
              {attendanceCall?.professionalName}
            </Text>
            <Text variant="paragraphSmall">
              {attendanceCall?.specialityName}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Space mt="lg" />
    </Modal>
  )
}

export default CallStartedModal
